import { render } from "./FilterSection.vue?vue&type=template&id=3054047e&scoped=true"
import script from "./FilterSection.vue?vue&type=script&lang=js"
export * from "./FilterSection.vue?vue&type=script&lang=js"

import "./FilterSection.vue?vue&type=style&index=0&id=3054047e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3054047e"]])

export default __exports__